import React from "react";

function Navbar({ activePage, setActivePage, darkMode, setDarkMode }) {
    return (
        <>
            {/* Górna nawigacja — tablet i komputer */}
            <nav className="top-nav">
                <div className="nav-logo" onClick={() => setActivePage("home")}>
                    K <span>&</span> B
                </div>
                <div className="nav-tabs">
                    <button
                        className={`nav-tab ${activePage === "home" ? "active" : ""}`}
                        onClick={() => setActivePage("home")}
                    >
                        🏠 Wesele
                    </button>
                    <button
                        className={`nav-tab ${activePage === "gallery" ? "active" : ""}`}
                        onClick={() => setActivePage("gallery")}
                    >
                        <span className="live-dot"></span>
                        📸 Galeria Live
                    </button>
                    <button
                        className={`nav-tab ${activePage === "tasks" ? "active" : ""}`}
                        onClick={() => setActivePage("tasks")}
                    >
                        🎯 Zadania
                    </button>
                    <button
                        className="nav-tab theme-tab"
                        onClick={() => setDarkMode(!darkMode)}
                    >
                        {darkMode ? "☀️ Tryb jasny" : "🌙 Tryb ciemny"}
                    </button>

                </div>
            </nav>

            {/* Dolna nawigacja — tylko telefon */}
            <nav className="bottom-nav">
                <div className="bottom-nav-inner">
                    <button
                        className={`bottom-tab ${activePage === "home" ? "active" : ""}`}
                        onClick={() => setActivePage("home")}
                    >
                        <span className="bottom-tab-icon">🏠</span>
                        <span className="bottom-tab-label">Wesele</span>
                    </button>
                    <button
                        className={`bottom-tab ${activePage === "gallery" ? "active" : ""}`}
                        onClick={() => setActivePage("gallery")}
                    >
                        <span className="bottom-tab-icon">📸</span>
                        <span className="bottom-tab-label">Galeria Live</span>
                    </button>
                    <button
                        className={`bottom-tab ${activePage === "tasks" ? "active" : ""}`}
                        onClick={() => setActivePage("tasks")}
                    >
                        <span className="bottom-tab-icon">🎯</span>
                        <span className="bottom-tab-label">Zadania</span>
                    </button>
                    <button
                        className="bottom-tab"
                        onClick={() => setDarkMode(!darkMode)}
                    >
                        <span className="bottom-tab-icon">{darkMode ? "☀️" : "🌙"}</span>
                        <span className="bottom-tab-label">{darkMode ? "Jasny" : "Ciemny"}</span>
                    </button>

                </div>
            </nav>
        </>
    );
}

export default Navbar;